import { hasPermission } from '@/utils/permission'

/**
 * 权限指令
 * 使用方式：
 * v-permission="'sysUser.manage.update'" - 单个权限
 * v-permission="['sysUser.manage.update', 'sysUser.manage.add']" - 多个权限（有任意一个即可）
 * v-permission.all="['sysUser.manage.update', 'sysUser.manage.add']" - 多个权限（需要全部拥有）
 */
function checkAuth(value, modifiers) {
  if (!value) return true
  if (Array.isArray(value)) {
    return modifiers.all
      ? value.every(code => hasPermission(code))
      : value.some(code => hasPermission(code))
  }
  return hasPermission(value)
}

export default {
  mounted(el, binding) {
    if (!checkAuth(binding.value, binding.modifiers)) {
      // 用 display:none 代替 removeChild，避免与 Vue 虚拟 DOM 协调冲突
      el.style.display = 'none'
    }
  }
}

